import { render, staticRenderFns } from "./Blade2.vue?vue&type=template&id=3fc47cdd"
import script from "./Blade2.vue?vue&type=script&lang=js"
export * from "./Blade2.vue?vue&type=script&lang=js"
import style0 from "./Blade2.vue?vue&type=style&index=0&id=3fc47cdd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports